import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { request } from "../utill";
import localforage from "localforage";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../components/LoadingSpinner";
import Layout from "../components/Layout"; 
import { useUser } from "../context/UserProvider";

function Login() {
  const [otpSent, setOtpSent] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [countdown, setCountdown] = useState(120);
  const [isOtpRequested, setIsOtpRequested] = useState(false);
  const [isLoading, setIsLoading] = useState(false); 
  const otpRefs = useRef([]);
  const navigate = useNavigate();
  const { saveUserData } = useUser();

  const handlePhoneChange = (e) => setPhoneNumber(e.target.value);

  const handleOtpChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value;
    if (value && index < otp.length - 1) otpRefs.current[index + 1].focus();
    setOtp(newOtp);
    if (newOtp.every((val) => val !== "")) validateAndSubmitOtp(newOtp);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      if (index > 0) otpRefs.current[index - 1].focus();
    } else if (e.key === "Backspace" && otp[index] !== "") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const validateAndSubmitOtp = async (otpCode) => {
    if (!otpSent) handleSubmit();
    const fullOtp = otpCode.join("");
    if (fullOtp.length === otp.length) await handleSubmit(fullOtp);
  };

  const handleSubmit = async (otpCode = "") => {
    setIsLoading(true);
    if (!otpSent) {
      if (phoneNumber.length === 11 && /^09\d{9}$/.test(phoneNumber) && !isOtpRequested) {
        setIsOtpRequested(true);
        const res = await request("/esalat-user/request-otp", "POST", { username: phoneNumber }, true);
        setIsLoading(false);
        if (res?.success) {
          setOtpSent(true);
          setCountdown(120);
          toast.success("کد تایید ارسال شد.", { rtl: true });
          otpRefs.current[0]?.focus();
        } else {
          toast.error(res.message || "خطا در ارسال کد تایید.", { rtl: true });
          res.errors?.forEach((err) => toast.error(err, { rtl: true }));
          setIsOtpRequested(false);
        }
      } else {
        setIsLoading(false);
        toast.error("لطفا شماره موبایل معتبر وارد کنید.", { rtl: true });
      }
    } else {
      const res = await request("/esalat-user/login-with-otp", "POST", { username: phoneNumber, otp_code: otpCode }, true);
      setIsLoading(false);
      if (res.success && res.jwt) {
        await localforage.setItem("jwt", res.jwt);
        saveUserData(res.user)
        toast.success("ورود موفقیت‌آمیز بود.", { rtl: true });
        navigate("/");
      } else {
        toast.error(res.message || "کد OTP نادرست یا منقضی شده است.", { rtl: true });
      }
    }
  };

  const handleResendOtp = async () => {
    if (countdown === 0) {
      setIsLoading(true);
      const res = await request("/esalat-user/request-otp", "POST", { username: phoneNumber }, true);
      setIsLoading(false);
      if (res.success) {
        setCountdown(120);
        toast.success("کد تایید مجدداً ارسال شد.", { rtl: true });
      } else {
        toast.error(res.message || "خطا در ارسال دوباره کد.", { rtl: true });
      }
    }
  };

  const handleReset = () => {
    setOtpSent(false);
    setOtp(["", "", "", "", "", ""]);
    setCountdown(120);
    setIsOtpRequested(false);
  };

  useEffect(() => {
    if (otpSent && countdown > 0) {
      const timerId = setInterval(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearInterval(timerId);
    }
  }, [otpSent, countdown]);

  const formatCountdown = () => {
    const minutes = String(Math.floor(countdown / 60)).padStart(2, "0");
    const seconds = String(countdown % 60).padStart(2, "0");
    return `${minutes}:${seconds}`;
  };

  return (
    <Layout>
      {isLoading && <LoadingSpinner />}
      <h1 className="login-title">ورود / ثبت نام</h1>
      {!otpSent ? (
        <>
          <p className="login-text">شماره موبایل خود را وارد کنید</p>
          <div className="AZ-field-group">
            <label htmlFor="phone">شماره موبایل</label>
            <input
              type="text"
              id="phone"
              placeholder="شماره موبایل"
              className="form-control"
              value={phoneNumber}
              onChange={handlePhoneChange}
            />
          </div>
        </>
      ) : (
        <>
          <p className="login-text">
            کد ارسال شده به شماره <span>{phoneNumber}</span> را وارد کنید
          </p>
          <div className="AZ-field-group">
            <fieldset className="number-code my-4">
              <div className="d-flex gap-2">
                {otp.map((code, index) => (
                  <input
                    key={index}
                    type="text"
                    maxLength="1"
                    value={code}
                    className="code-input"
                    onChange={(e) => handleOtpChange(e.target.value, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    ref={(el) => (otpRefs.current[index] = el)}
                  />
                ))}
              </div>
            </fieldset>
          </div>
          <div className="d-flex align-items-center justify-content-between w-100">
            <a href="#" className="change-number" onClick={handleReset}>تغییر شماره</a>
            <p className="get-code-again text-center my-3" onClick={handleResendOtp} style={{ cursor: countdown === 0 ? "pointer" : "default", color: countdown === 0 ? "blue" : "gray" }}>
              دریافت دوباره کد ({countdown === 0 ? "کلیک کنید" : <span id="countdown">{formatCountdown()}</span>})
            </p>
          </div>
        </>
      )}
      <div className="login-footer w-100">
        <button
          type="submit"
          disabled={isOtpRequested || isLoading}
          className="AZ-primary-btn d-flex align-items-center justify-content-center w-100"
          onClick={() => validateAndSubmitOtp(otp)}
        >
          {otpSent ? "ورود" : "ادامه"}
        </button>
      </div>
    </Layout>
  );
}

export default Login;
